import Vue from 'vue'

class EventBus extends Vue {

    register(event: string, callback: Function) {
        this.$on(event, callback)
        this.$emit('LST_' + event, true)
    }

    unregister(event: string) {
        this.$off(event)
        this.$emit('LST_' + event, false)
    }

    isRegistered(event: string, callback: Function) {
        let functions = this.$listeners[event]
        if (functions && (!Array.isArray(functions) || (functions as Array<Function>).length > 0)) {
            callback(true)
        } else {
            callback(false)
        }
        this.$on('LST_' + event, (isRegistered: boolean) => {
            callback(isRegistered)
        })
    }

    stopRegistered(event: string) {
        this.$off('LST_' + event)
    }
}
export default new EventBus()